import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SessionService } from "../session.service";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private SessionService: SessionService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    //Dont add auth header to outgoing requests
    if (request.headers.get("skipIntercept") === "true") {
      const nonInterceptedRequest = request.clone({
        headers: request.headers.delete("skipIntercept"),
      });
      return next.handle(nonInterceptedRequest);
    }

    const currentUser = this.SessionService.currentUserValue;
    if (currentUser) {
      const authenticatedRequest = request.clone({
        headers: request.headers.set("Authorization", currentUser.authToken),
      });
      return next.handle(authenticatedRequest);
    } else {
      return next.handle(request);
    }
  }
}
